module.exports = __webpack_public_path__ + "media/images/pic/program-rozwoju-obszarow-wiejskich-a841821b747a0276c82347ee00763965.jpeg";